import { config } from '@/config/config';
import { useDevice } from '@/hooks/use-device';
import { getDefaultMapProps } from '../../../../utils/map';
import { DesktopMap } from '../desktop-map';
import { FiltersProvider } from '../filters-provider';
import { MapViewportFilterProvider } from '../map-viewport-filter-provider';
import { MobileMap } from '../mobile-map/mobile-map';
import { PlaceInfoProvider } from '../place-info-provider';
import classes from './world-map.module.css';

/**
 * @returns {React.JSX.Element}
 */
export function WorldMap() {
  const { isMobile } = useDevice();
  const defaultMapProps = getDefaultMapProps({ mapId: config.mapId });

  return (
    <MapViewportFilterProvider>
      <FiltersProvider>
        <PlaceInfoProvider>
          <div className={classes.worldMap}>
            {isMobile ? <MobileMap mapProps={defaultMapProps} /> : <DesktopMap mapProps={defaultMapProps} />}
          </div>
        </PlaceInfoProvider>
      </FiltersProvider>
    </MapViewportFilterProvider>
  );
}
